function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_17",
  "data-name": "Rectangle 17",
  width: 29,
  height: 29,
  transform: "translate(0 0.259)",
  fill: "none"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Inteligentny_obiekt_wektorowy",
  "data-name": "Inteligentny obiekt wektorowy",
  transform: "translate(0 -0.259)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_26",
  "data-name": "Group 26"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_25",
  "data-name": "Group 25",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_24",
  "data-name": "Path 24",
  d: "M27.664,8.433q-.65.738-1.284,1.487A12.738,12.738,0,1,1,13.557,1.8q.469-.034.937-.034a12.739,12.739,0,0,1,7.048,2.124q.555-.689,1.122-1.37a14.54,14.54,0,1,0,5,5.915",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_25",
  "data-name": "Path 25",
  d: "M27.934,4.569l.009-.09a11.839,11.839,0,0,0,.009-2.317c-.01-.11-.071-.62-.178-1.116-.137-.634-.289-.984-.453-1.039-.027-.009-.1-.033-.2.079a103.9,103.9,0,0,0-12.6,16.994l-.805,1.359-.734-1.4a42.885,42.885,0,0,0-5.5-8.088.224.224,0,0,0-.163-.1.123.123,0,0,0-.042.007c-.16.057-.3.428-.406,1.1-.081.5-.119,1.012-.122,1.1a12.312,12.312,0,0,0,.119,2.309c.011.064.02.13.031.2a2.4,2.4,0,0,0,.382,1.17,40.506,40.506,0,0,1,6.205,9.57c.055.12.2.4.345.405h0c.076,0,.127-.072.152-.115A103.492,103.492,0,0,1,27.6,5.864a2.762,2.762,0,0,0,.338-1.295",
  fill: "#fff"
}))));

var SvgTest = function SvgTest(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTest, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/test.f7a7f8fd.svg";
export { ForwardRef as ReactComponent };